module.exports = "<p *ngFor=\"let item of errors | keyvalue\">\r\n  {{ getError(item.key) }}\r\n</p>"